import React, { useCallback, useContext, useState } from 'react'

import { Button,Div } from '@driftt/tide-core'
import { FeatureTooltip } from '@driftt/tide-tooltips'

import { toggleUserProperty } from 'api'
import { CurrentUserContext } from 'context/currentUserContext'

import styles from './styles.module.css'

const USER_PROPERTY = 'unifiedFeedBetaOptOut'

const HEADER_COPY = 'A new experience is available!'
const BODY_COPY =
  'Our account activity tools are evolving to be more powerful for reps like you. Switch to the new Activity Feed to see a new look and feel for the same activity data on your accounts.'

const OptInBanner: React.FC = () => {
  const currentUser = useContext(CurrentUserContext)
  const [showTooltip, setShowTooltip] = useState(false)

  const handleOptIn = useCallback(() => {
    if (currentUser) {
      toggleUserProperty(currentUser.id, USER_PROPERTY, false).then(() => window.location.reload())
    }
  }, [currentUser])

  return (
    <Div className={styles.Banner}>
      <Div className={styles.BannerCenter}>
        <Button className={styles.BannerButton} onClick={handleOptIn}>
          Switch to the new Activity Feed
        </Button>
        <FeatureTooltip
          ribbonType="new"
          className={styles.Tooltip}
          showTooltip={showTooltip}
          headerCopy={HEADER_COPY}
          bodyCopy={BODY_COPY}
          tooltipSide="bottom"
          tooltipCaretLocation="center"
          onClose={() => setShowTooltip(false)}>
          <span
            className={styles.LearnMore}
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}>
            Learn more
          </span>
        </FeatureTooltip>
      </Div>
    </Div>
  )
}

export default OptInBanner
